import "babel-polyfill"
import 'raf/polyfill'
// import './styles/bundle.css'

import React from 'react';
import ReactDOM from 'react-dom';
import { Router } from 'react-router'
import createBrowserHistory from 'history/createBrowserHistory';
import { Provider, onError } from 'mobx-react';
import { syncHistoryWithStore } from 'mobx-react-router';
import { configure } from "mobx";

import App from './components/App';
import config from './utils/config'
import registerServiceWorker from './registerServiceWorker';

import './utils/mobxFormatter'

import routingStore from './stores/routingStore'
import commonStore from './stores/commonStore'
import userStore from './stores/userStore'
import categoriesStore from './stores/categoriesStore'
import authStore from './stores/authStore'
import noAccountModalStore from './stores/noAccountModalStore'
import translationStore from './stores/translationStore'
import guidedIntroductionStore from './stores/guidedIntroductionStore'
import dropdownStore from './stores/dropdownStore'
import pagesStore from './stores/pagesStore'
import searchStore from './stores/searchStore'
import registrationStore from './stores/registrationStore'
import confirmCustomerStore from './stores/confirmCustomerStore'
import favoritesStore from './stores/favoritesStore'
import errorStore from './stores/errorStore'
import exploreStore from './stores/exploreStore'
import confirmLeadStore from './stores/confirmLeadStore'
import loadingAnimationStore from './stores/loadingAnimationStore'
import profileStore from './stores/profileStore'
import payoffStore from './stores/payoffStore'
import testimonialsStore from './stores/testimonialsStore'
import contactStore from './stores/contactStore'
import faqStore from './stores/faqStore'
import passwordRecoverStore from './stores/passwordRecoverStore'
import changePasswordStore from './stores/changePasswordStore'
import reactivateStore from './stores/reactivateStore'
import changeEmailStore from './stores/changeEmailStore'
import unsubscribeEmailStore from './stores/unsubscribeEmailStore'
import infoStore from './stores/infoStore'
import instaRegistrationStore from './stores/instaRegistrationStore'
import registrationStoreDE from './stores/registrationStoreDE'
import confirmAccountStore from './stores/confirmAccountStore'
import './css/fontawesome-all.css'

const browserHistory = createBrowserHistory();

const stores = {
  commonStore,
  routingStore,
  translationStore,
  userStore,
  guidedIntroductionStore,
  categoriesStore,
  dropdownStore,
  authStore,
  pagesStore,
  searchStore,
  registrationStore,
  confirmCustomerStore,
  favoritesStore,
  errorStore,
  faqStore,
  confirmLeadStore,
  loadingAnimationStore,
  profileStore,
  payoffStore,
  noAccountModalStore,
  testimonialsStore,
  contactStore,
  exploreStore,
  passwordRecoverStore,
  changePasswordStore,
  reactivateStore,
  changeEmailStore,
  unsubscribeEmailStore,
  infoStore,
  instaRegistrationStore,
  registrationStoreDE,
  confirmAccountStore
}
configure({ enforceActions: true });
// Global error handler
onError(error => {
  console.log(error)
})

const history = syncHistoryWithStore(browserHistory, routingStore)

// For easier debugging
window._____APP_STATE_____ = stores;

const link = document.querySelector("link[rel*='icon']") || document.createElement('link')
link.type = 'image/x-icon'
link.rel = 'shortcut icon'
link.href = config.favicon || translationStore.translate('favicon')
document.getElementsByTagName('head')[0].appendChild(link)

document.title = config.title

ReactDOM.render((
  <Provider {...stores}>
    <Router history={history}>
      <App />
    </Router>
  </Provider>
), document.getElementById('root'))

config.host === 'localhost' && registerServiceWorker()



// WEBPACK FOOTER //
// ./src/index.js